import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
import { Message } from "element-ui";

const account = {
  state: () => ({
    connected:true,
  }),
  actions: {
    async changePassword(store, payload) {
      var res = await axios.post("account/changepassword", payload);
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    },
    async deleteMyAccount(store, payload) {
      var res = await axios.post("account/deletemyaccount", payload);
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    },
    async toggleAccountNotifications(store, payload) {
      var res = await axios.post("account/togglenotifications", payload);
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    },
    async updateAccountProfile(store, payload) {
      var res = await axios.post("account/updateprofile", payload);
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    },
    async addUpdateAccountJob(store, payload) {
      var res = await axios.post("account/addorupdatejob", payload);
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    },
    async removeAccountJob(store, payload) {
      var res = await axios.post("account/removejob", { id: payload });
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    },
    async addUpdateAccountSchool(store, payload) {
      var res = await axios.post("account/addorupdateschool", payload);
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    },
    async removeAccountSchool(store, payload) {
      var res = await axios.post("account/removeschool", { id: payload });
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    },
    async addUpdateAccountLanguage(store, payload) {
      var res = await axios.post("account/addorupdatelanguage", payload);
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    },
    async removeAccountLanguage(store, payload) {
      var res = await axios.post("account/removelanguage", { id: payload });
      if (res.data.hasError) {
        Message.error(res.data.message);
      } else {
        Message.success(res.data.message);
      }
      return res;
    }
  },
  mutations: {
    setConnected(state,data){
      state.connected = data;
    }
  },
  getters: {
    getConnection: (state) => state.connected
   }
};
export default account;



// WEBPACK FOOTER //
// ./src/store/account.js